import { all, call, fork, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { UserInfoActionTypes } from './types'
import { listSuccess, listError } from './actions'
import { GeneralUtil } from '../../utils/generalUtil';
import { Table } from '../interface'
import { authProvider } from '../../utils/authProvider';

const generalUtil: GeneralUtil = new GeneralUtil();

const getRecords = async (searchParams: any) => {
  searchParams.table = Table.User;
  return await generalUtil.GetList(searchParams);
}

const getUser = async(searchParams: any) => {
  let accountInfo = await authProvider.getAccountInfo();
  let id: string = accountInfo === null ? '' : accountInfo?.account.accountIdentifier;
  
  return await generalUtil.Read(id, 'User');
}

function* handleList(action: any) {
  try {
    //const res = yield call(getRecords, action.payload);
    const res = yield call(getUser, action.payload);
    // console.log("res");
    // console.log(res);
    if (res.isSuccess) {
      yield put(listSuccess(res))
    } else {
      yield put(listError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(listError(err.stack))
    } else {
      yield put(listError('An unknown error occured.'))
    }
  }
}

function* watchListRequest() {
  yield takeEvery(UserInfoActionTypes.LIST_REQUEST, handleList)
}

function* UserInfosSaga() {
  yield all([
    fork(watchListRequest),
  ]);
}

export default UserInfosSaga
